import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { Geist, Geist_Mono, Instrument_Serif } from 'next/font/google'

const sans = Geist({
    subsets: ['latin']
})

const mono = Geist_Mono({
    subsets: ['latin']
})

const serif = Instrument_Serif({
    subsets: ['latin'],
    weight: '400'
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${serif.style.fontFamily};--font-geist-sans:${sans.style.fontFamily};--font-instrument-serif:${serif.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <Component {...pageProps} />
        </div>
    )
}

export default App